import React from "react";
import VideoIMG from "../../../assets/careers-video-image.jpg";
import { Link } from "react-router-dom";

const CareersVideoSection = ({ learn_more_about_lc }) => {
  const defaultTitle = "Reimagining Software, Empowering the Tourism Economy";
  const defaultContent =
    "Join our close-knit, dynamic team at Laguna Creek, as we embark on an exciting mission to craft cutting-edge software that will revolutionize Indigenous tourism. We're not just building apps; we're creating immersive, feature-packed experiences that will outshine the giants in the hospitality and tourism industries. Our team is a force to be reckoned with, fueled by a burning passion to harness the latest technology and transform it into user-friendly, robust applications that will leave a lasting impact on people's lives.";
  const defaultVideoIMG = VideoIMG;
  const defaultBtnText = "Learn more about lagunacreek";
  const defaultBtnURL = "/about-us";

  const title = learn_more_about_lc?.title || defaultTitle;
  const content = learn_more_about_lc?.content || defaultContent;
  const image = learn_more_about_lc?.image || defaultVideoIMG;
  const btntext = learn_more_about_lc?.button_text || defaultBtnText;
  const btnurl = learn_more_about_lc?.button_url || defaultBtnURL;

  const getPlainText = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  return (
    <>
      <section className="py-10 lg:py-20">
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap items-center -mx-4">
            <div className="w-full lg:w-1/2 max-w-full px-4 text-center lg:text-left">
              <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-4">
                {title}
              </h3>
              <p className="text-lg font-light leading-7 text-[#333333] mb-4">
                {getPlainText(content)}
              </p>
              <Link
                to={btnurl}
                className="inline-block text-lg font-bold leading-6 text-[#5FA3B2] bg-[transparent] transition-all ease-in-out duration-500 hover:text-[#FAA42A] mb-8 lg:mb-0"
              >
                {btntext}
              </Link>
            </div>
            <div className="w-full lg:w-1/2 max-w-full px-4 text-right">
              <div className="lg:inline-block relative">
                <img
                  src={image}
                  alt="OurStory"
                  className="rounded-[21px] mx-auto"
                  height="841"
                  width="663"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CareersVideoSection;
